module.exports = __webpack_public_path__ + "static/media/olake-banner-vector.65b5b8cd.svg";